import { createSelector, Selector } from 'reselect'

import { PermissionsState } from './permissions.reducer'

import Permission from '../model/permissions.model'

import { RootState } from '~/core/store/root.reducer'

type GetPermissions = Selector<RootState, PermissionsState>
const getPermissions: GetPermissions = (state) => state.permissions

export const selectPermissions = createSelector(getPermissions, (permissions) => permissions?.data)

export const selectHasPermission = (permissionId: Permission) =>
  createSelector(selectPermissions, (permissions) => permissions?.includes(permissionId))

export const selectPermissionsLoading = createSelector(
  getPermissions,
  (permissions) => permissions?.loading,
)

export const selectPermissionsError = createSelector(
  getPermissions,
  (permissions) => permissions?.error,
)
